<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 40 40" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <g data-follow-fill="currentColor" :fill="_fill">
        <path d="M23.3 4.5zm15.3 20c-1.8-3.2-5.2-5.1-8.9-5.1-5.7 0-10.3 4.6-10.3 10.3S24 40 29.7 40c3.7 0 7.1-2 8.9-5.1 1.9-3.3 1.9-7.2 0-10.4zm-5 9.7c-.5.5-1.2.6-1.6.2l-3.5-3.1c-.2-.2-.3-.4-.3-.6v-7.3c0-.3.1-.6.3-.8.2-.2.5-.3.8-.3h.3c.5.1.9.5.9 1.1v6.4l3.1 2.8c.4.4.4 1.1 0 1.6zM29 22.3z" />
        <path d="M28.4 0H7.3C3.3 0 0 3.3 0 7.3v25.4c0 4 3.3 7.3 7.3 7.3H21c-1.1-.9-2-2-2.8-3.2H7.3c-2.2 0-4.1-1.8-4.1-4.1V7.3c0-2.2 1.8-4.1 4.1-4.1h21.1c2.2 0 4.1 1.8 4.1 4.1v9.2c1.1.2 2.2.6 3.2 1.1V7.3c0-4-3.3-7.3-7.3-7.3z" />
        <path d="M25.8 10.8h-16c-.9 0-1.6-.7-1.6-1.6s.7-1.6 1.6-1.6h16c.9 0 1.6.7 1.6 1.6s-.7 1.6-1.6 1.6zm-10 8h-6c-.9 0-1.6-.7-1.6-1.6s.7-1.6 1.6-1.6h6c.9 0 1.6.7 1.6 1.6s-.7 1.6-1.6 1.6z" />
      </g>
    </g>
  </svg>
</template>

<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
